export const SET_SLIDE_TO_INDEX = "SET_SLIDE_TO_INDEX";
export const RESET_SLIDE_TO_INDEX = "RESET_SLIDE_TO_INDEX";
